<script setup lang="ts">
import {computed, ref} from "vue";

interface Props {
    modelValue: string | null,
    label: string,
    required?: boolean,
    errors?: string
    placeholder?: string,
}
const props = withDefaults(defineProps<Props>(), {
    required: false,
    errors: undefined,
    placeholder: undefined,
})
const emit = defineEmits(['update:modelValue'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
const isActive = ref(false)
const bgColor = computed(() => {
    if (isActive.value) {
        return 'white'
    }
    return 'grey-lighten-4'
})
</script>

<template>
    <label class="black--text font-weight-bold text-body-2">{{ label }} <span
        v-if="required"
        class="text-error"
    >*</span></label>
    <v-textarea
        v-model="value"
        variant="outlined"
        class="mt-2"
        :placeholder="placeholder"
        :error-messages="errors"
        density="compact"
        rounded="lg"
        color="blue"
        :bg-color="bgColor"
        @focus="isActive = true"
        @blur="isActive = false"
    />
</template>

<style scoped>

</style>
